import { render, staticRenderFns } from "./vertical-timeline.vue?vue&type=template&id=42936f30&scoped=true&"
import script from "./vertical-timeline.vue?vue&type=script&lang=js&"
export * from "./vertical-timeline.vue?vue&type=script&lang=js&"
import style0 from "./vertical-timeline.vue?vue&type=style&index=0&id=42936f30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42936f30",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VTimeline,VTimelineItem})
